// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"613b8662","239":"ce307206","646":"ac4a827e"}[chunkId] + ".chunk.js";
};